const loading_card = {
	description: "Dies kann einige Minuten dauern",
	title: "Ihr VPS wird erstellt...",
};

export default loading_card;
